export default __webpack_public_path__ + "static/media/microsoftoffice.c3a1f4f1.svg";